// TODO: Should these vary by environment?
export const PDF_LIST = {
  privacyPolicy: 'https://itrvl-dev-media.imgix.net/itrvl_privacy_policy_7_13_20.pdf',
  termsAndConditions: 'https://cdn-media.itrvl.com/itrvl%20traveler%20T%26Cs%2030-Jun-21.pdf',
  termsAgent: 'https://itrvl-dev-media.imgix.net/itrvl_Agent Terms of Use_site.pdf',
  escrow: 'https://cdn-media.itrvl.com/itrvl%20why%20ESCROW.pdf',
  escrowNew: 'https://cdn-media.itrvl.com/itrvl+Escrow+Process.png',
  wireTransferDetails: 'https://cdn-media.itrvl.com/itrvl+Wire+Transfer+Details.pdf',
  wireTransferDetails3P: 'https://cdn-media.itrvl.com/itrvl+Wire+Transfer+Details+3P.pdf',
};
